import style from './style.module.scss'
export const Loading = () => {
    return (
        <section id="preloader" className={style.load}>
            <section id="loader_pre" className={style.loader}>Loading ...</section>
        </section>
    )
}